import { applyMiddleware } from 'redux'
import { legacy_createStore as createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import rootReducer from './rootReducer'
import thunk from 'redux-thunk'
import { persistStore } from 'redux-persist'

const getMiddleware = () => {
    return process.env.NODE_ENV === 'production'
        ? applyMiddleware(thunk)
        : applyMiddleware(thunk)
}

export const store = createStore(rootReducer, composeWithDevTools(getMiddleware()))
export const persistor = persistStore(store)
export default { store, persistor }
